<template>
  <notifications
    group="ConveyNotification"
    position="bottom left"
    :width="notificationWidth"
  >
    <template slot="body" slot-scope="props">
      <div
        class="convey-notification d-flex border rounded bg-white-custom"
        :class="{
          'border-success': props.item.type === 'success',
          'border-warning': props.item.type === 'warning',
          'border-danger': props.item.type === 'error',
          'border-info': props.item.type === 'info',
          'ml-3': !optimized,
          'ml-2': optimized,
          'mb-2': !optimized,
          'mb-1': optimized,
        }"
      >
        <div
          class="convey-notification--icon d-flex align-items-center justify-content-center"
          :class="{
            'bg-success': props.item.type === 'success',
            'bg-warning': props.item.type === 'warning',
            'bg-danger': props.item.type === 'error',
            'bg-info': props.item.type === 'info',
            optimized,
          }"
        >
          <b-icon
            v-if="props.item.type === 'success'"
            icon="check-lg"
            :scale="optimized ? 1 : 2"
          />
          <b-icon
            v-else-if="props.item.type === 'warning'"
            icon="exclamation-triangle"
            :scale="optimized ? 1 : 2"
          />
          <b-icon
            v-else-if="props.item.type === 'error'"
            icon="exclamation-lg"
            :scale="optimized ? 1 : 2"
          />
          <b-icon
            v-else-if="props.item.type === 'info'"
            icon="info-lg"
            :scale="optimized ? 1 : 2"
          />
        </div>
        <div
          class="convey-notification--content"
          :class="{
            optimized,
            'px-2': optimized,
            'py-2': optimized,
            general: !optimized,
            'px-3': !optimized,
            'py-3': !optimized,
          }"
        >
          <h5
            v-if="props.item.title"
            :class="{
              'text-success': props.item.type === 'success',
              'text-warning': props.item.type === 'warning',
              'text-danger': props.item.type === 'error',
              'text-info': props.item.type === 'info',
            }"
          >
            {{ props.item.title }}
          </h5>
          <p v-html="props.item.text" class="mb-0 font-weight-medium"></p>
        </div>
      </div>
    </template>
  </notifications>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "ConveyNotification",
  data() {
    return {
      optimized: false,
      notificationWidth: 300,
    };
  },
  computed: {
    ...mapGetters("user", ["viewport"]),
  },
  watch: {
    viewport: {
      handler(viewport) {
        this.notificationWidth = viewport.innerWidth - 16;
        this.optimized = viewport.innerWidth < 768;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.convey-notification {
  &.rounded {
    border-radius: 5px !important;
  }
  &--icon {
    min-width: 50px;
    min-height: 50px;
    border-radius: 4px 0 0 4px;
    color: white;
    &.optimized {
      min-width: 40px;
      min-height: 40px;
    }
  }

  &--content {
    &.general {
      min-width: 270px;
      width: max-content;
    }
    &.optimized {
      flex: 1;
    }
    border: 1px solid transparent;
    border-radius: 0 4px 4px 0;
    h5 {}
    p {}
  }
}
</style>
